import { flattenDeep } from './objectHelpers';

export const compareStringsCaseInsensitively = (...args) => {

    // compareStringsCaseInsensitively takes:
    // valueToCheck - 1st param;
    // valuesToMatch - rest of params (at least 1 but can be more). They might be strings or array of strings or their combination.

    if(args.length < 2) {
        console.error('Comparison cannot be executed by =compareStringsCaseInsensitively= because of lack of arguments');
        return false;
    }

    const [ valueToCheck, ...valuesToMatch ] = args;

    const flattenedValuesToMatch = flattenDeep(valuesToMatch);

    const areStrings = [ valueToCheck, ...flattenedValuesToMatch ]
        .every(string => typeof string === 'string' || string instanceof String);

    if(areStrings) {
        return flattenedValuesToMatch.some(v => v.toLowerCase() === valueToCheck.toLowerCase());
    } else {
        console.error('At least one of strings provided to =compareStringsCaseInsensitively= is not a string');
        return false;
    }
};